import {
  BarChart3,
  FileText,
  Database,
  Download,
  Folder,
} from 'lucide-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { HubShell } from '@/components/layout/HubShell';
import AnalyticsPage from './AnalyticsPage';
import { ContentExtractionPage } from './ContentExtractionPage';
import AdvancedContentAnalysis from './AdvancedContentAnalysis';
import { DataAggregationPage } from './DataAggregationPage';
import AttributionTracker from './AttributionTracker';
import CitationTrackingSystem from './CitationTrackingSystem';
import { ExportCenterPage } from './ExportCenterPage';
import BackupCenter from './BackupCenter';
import ImportCenter from './ImportCenter';

/**
 * Insights hub — analytics, content, search, data, export, and backup.
 */
export function InsightsHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('section') === 'search') {
      const next = new URLSearchParams(searchParams);
      next.set('section', 'overview');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const tabs = [
    {
      id: 'overview',
      label: 'Overview',
      icon: BarChart3,
      render: () => <OverviewTab />,
    },
    {
      id: 'content',
      label: 'Content',
      icon: FileText,
      render: () => (
        <div className="space-y-6">
          <ContentExtractionPage />
          <AdvancedContentAnalysis />
          <CitationTrackingSystem />
        </div>
      ),
    },
    {
      id: 'data',
      label: 'Data',
      icon: Database,
      render: () => (
        <div className="space-y-6">
          <DataAggregationPage />
          <AttributionTracker />
        </div>
      ),
    },
    {
      id: 'export',
      label: 'Export',
      icon: Download,
      render: () => <ExportCenterPage />,
    },
    {
      id: 'backup',
      label: 'Backup',
      icon: Folder,
      render: () => (
        <div className="space-y-6">
          <BackupCenter />
          <ImportCenter />
        </div>
      ),
    },
  ];

  return (
    <HubShell
      title="Insights"
      description="Analytics, content, data, export, and backup."
      icon={BarChart3}
      tabs={tabs}
      defaultSection="overview"
    />
  );
}

function OverviewTab() {
  return <AnalyticsPage />;
}

export default InsightsHubPage;
